<template>
  <v-container
    id="container-wrap"
    fluid
    pa-0
    v-show="isAuthorized && isShow"
  >
    <pdf-header
      :disabled-finish="Object.keys(signed).length !== elements.length"
      :signed-pdf="signedPdf"
      :company-logo="companyLogo"
      :document-name="documentName"
      :show-finish="false"
      :is-view="true"
      :environment="environment"
      :signed-date="signedDate"
      :signee-name="signeeName"
      :signed-signees="signedSignees"
      ref="signPDFReviewHeader"
    />
    <!-- Actions Bar -->
    <v-row
      class="action-bar"
      style="max-height: 70px !important; min-height: 70px !important;"
    >
      <v-col
        md="1"
        lg="1"
        xl="1"
        sm="auto"
        xs="auto"
      />
      <v-col
        cols="auto"
        class="pr-0 pl-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="handleDownload"
        >
          Download
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-0 pl-3"
      >
        <v-btn
          color="primary"
          outlined
          @click="redirect()"
        >
          Back to {{ getModuleName() }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pt-2"
      >
        <pdf-navigation
          :page="page"
          :pages-count="pagesCount"
          @increment="page++"
          @decrement="page--"
        />
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        style="width: 250px !important;"
        v-if="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm'"
      >
        <v-btn
          class="TierButton pb-0 text-center ml-1"
          icon
          @click="setPdfZoom(currentZoom - 0.2)"
        >
          <v-icon style="color: black;">
            mdi-magnify-minus-outline
          </v-icon>
        </v-btn>
        <v-btn
          class="TierButton pb-0 text-center ml-1"
          outlined
          width="110"
          height="30"
          @click="resetPdfZoom()"
        >
          RESET ZOOM
        </v-btn>
        <v-btn
          class="TierButton pb-0 text-center"
          icon
          @click="setPdfZoom(currentZoom + 0.2)"
        >
          <v-icon style="color: black;">
            mdi-magnify-plus-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        md="1"
        lg="1"
        xl="1"
        sm="auto"
        xs="auto"
      />
    </v-row>
    <v-row
      no-gutters
      class="content-pdf-view"
    >
      <v-col
        cols="2"
        class="text-right"
        style="padding-right: 4vw; padding-top: 8vh;"
      >
        <v-data-table
          :items="documentList"
          :hide-default-header="true"
          :hide-default-footer="true"
          style="z-index: 100; position: absolute;"
        >
          <template v-slot:item="{ item }">
            <tr
              :style="{
                background: item.id == currentDocument ? 'lightgreen' : 'white',
                color: 'black',
              }"
            >
              <td
                style="font-size: 18px;"
                @click="changeCurrentDocument(item)"
              >
                {{ item.originalName }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        cols="10"
        lg="8"
      >
        <v-card
          class="mx-auto elevation-0"
          :loading="isLoading"
        >
          <canvas
            ref="canvas"
            class="sx-absolute-centered"
            :style="{ zIndex: 1 }"
          />
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row
      dense
      class="signUpFooter px-4 align-center mt-0"
      align="center"
      v-show="showSignUpFooter"
    >
      <v-spacer />
      <v-col
        class="text-center text-subtitle-1 align-center"
        style="color: white;"
        align="center"
        cols="auto"
      >
        {{ signUpMessage
        }}<v-btn
          color="primary"
          depressed
          class="ml-3"
          href="https://www.systemx.net/try"
          target="_blank"
        >
          <v-icon>mdi-account-multiple-plus</v-icon><span class="pl-1"> Sign Up!</span>
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
      >
        <v-btn
          icon
          @click="showSignUpFooter = false"
          color="white"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <pdf-footer
      :is-signed="true"
      :transaction-id="transactionId"
      :token="token"
      :transaction-status-id="transactionStatusId"
    />
    <v-snackbar
      v-model="snackbar"
      color="#4caf50"
      top
    >
      <v-row align="center">
        <v-col
          cols="auto"
          class="pt-0 pb-0"
        >
          <span style="font-size: 16px; color: white;">This document has been already signed. You can close the tab/page now.</span>
        </v-col>
        <v-col class="text-end pt-0 pr-0 pb-0">
          <a
            @click="snackbar = false"
            style="color: white; font-size: 16px; text-decoration: none;"
          >CLOSE</a>
        </v-col>
      </v-row>
    </v-snackbar>

    <v-snackbar
      v-model="snackbarTimer"
      color="success"
      top
      :timeout="11000"
    >
      <v-row align="center">
        <v-col
          class="pt-0 pb-0"
          style="white-space: nowrap;"
        >
          <span style="font-size: 16px; color: white;">This document has been already signed.</span> <span style="font-size: 16px; color: white;">You will be redirected to SystemX Portal in</span> <span style="font-size: 20px; font-weight: bold; color: white;">{{ timer }}</span>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col>
          <span style="font-size: 16px; color: white;">You will be redirected to SystemX Portal in</span> <span style="font-size: 20px; font-weight: bold; color: white;">{{ timer }}</span>
        </v-col>
      </v-row> -->
      <v-row>
        <v-spacer />
        <v-col
          class="pb-0"
          cols="auto"
        >
          <v-btn
            text
            @click="stopTimer()"
          >
            Cancel Timer
          </v-btn>
        </v-col>
        <v-col
          class="pb-0"
          cols="auto"
        >
          <v-btn
            color="#FFFFFF"
            @click="redirect()"
            elevation="0"
          >
            <span style="color:  rgb(76, 175, 8)"> Redirect right now</span>
          </v-btn>
        </v-col>
        <v-spacer />
      </v-row>
    </v-snackbar>
  </v-container>
</template>

<script>
import pdf from '@/mixins/pdf';
import { rgb } from 'pdf-lib';
import hover from '@/mixins/hover';
import PdfNavigation from '@/components/SignPdf/PdfNavigation';
import dayjs from 'dayjs';
import PdfHeader from '@/components/SignPdf/Sign/PdfHeader.vue';
import PdfFooter from '@/components/SignPdf/Sign/PdfFooter.vue';

import Bus from '@/bus';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import moment from 'moment';

export default {
  components: { PdfNavigation, PdfHeader, PdfFooter },
  mixins: [pdf, hover],
  data() {
    return {
      showDateModal: false,
      showSignatureModal: false,
      showSignaturePad: false,
      hovering: -1,
      signing: -1,
      signingDate: dayjs().format('YYYY-MM-DD'),
      isLoading: true,
      datepickerMenu: false,
      isAuthorized: false,
      isShow: false,
      file: '',
      companyLogo: '',
      elements: [],
      documentName: '',
      signUpMessage:
        "If you like 'SystemX Sign', please register for your free trial here!",
      showSignUpFooter: true,
      environment: '',
      signedDate: '',
      signeeName: '',
      isView: true,
      fileName: '',
      documentList: [],
      currentDocument: null,
      activeDocument: null,
      signedPlacements: [],
      fileToDownload: null,
      signedPdfList: [],
      originalDocumentsList: [],
      transactionId: 0,
      token: '',
      transactionStatusId: 0,
      currentZoom: 1,
      signedSignees: [],
      signedByName: null,
      snackbar: false,
      snackbarTimer: false,
      timer: 0,
      moduleId: null,
      moduleIdExpense: 2,
      moduleIdTimesheet: 6,
      moduleIdPO: 12,
      moduleRecordId: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query && to.query.token && to.query.environment) {
      const token = to.query.token;
      const environment = to.query.environment;
      const redirect = to.query.redirect ? to.query.redirect : null;
      next((vm) => {
        vm.init(token, environment, redirect);
      });
    }
     else {
      alert('Error: Acces is not allowed');
    }
  },
  watch: {},
  mounted() {
    this.isLoading = false;
  },
  methods: {
    async init(token, environment, redirect) {
      this.token = token;
      this.environment = environment;
      var isAuthorized = await this.authorize(token);
      if (isAuthorized) {
        this.getDocumentData(token);
        this.getDocuments(token);
        //this.downloadSignedPDF(token);
        this.downloadCompanyLogo(token);
        this.isAuthorized = true;
        this.isShow = true;

        if(redirect)
        {
          this.startTimer();
          this.snackbarTimer = true;
          this.moduleId = redirect;
        }
        else
          this.snackbar = true;
      }
    },
    async authorize(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token };
        const res = await this.$api.post(
          `sign-pdf/envelopes/authorize-view`,
          data
        );
        this.isLoading = false;
        if (res.status === 200) {
          this.isError = false;
          return true;
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;

        let errorMessage = error;
        let errorCode = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorCode = error.response.data.message;
            switch (errorCode) {
              case '1000':
                errorMessage = 'Error: Document envelope not found.';
                break;
              case '1001':
                errorMessage = 'Error: Document not signed yet.';
                break;
              case '1003':
                errorMessage = 'Error: Document cancelled by creator.';
                break;
              case '1004':
                errorMessage = 'Error: Document declined by signee.';
                break;
              case '1005':
                errorMessage = 'Error: Document no longer available.';
                break;
              case '1006':
                errorMessage = 'Error: Document expired.';
                break;

              default:
                break;
            }
          }
        }

        this.isError = true;
        this.message = errorMessage;
        Bus.$emit('alert', 'error', this.message);
        return false;
      }
    },
    setPdfZoom(incomingZoom)
    {
      this.currentZoom = incomingZoom
      this.setZoom(this.currentZoom)
    },
    resetPdfZoom()
    {
      this.currentZoom = 1
      this.setZoom(this.currentZoom)
    },
    async downloadCompanyLogo(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token, IsView: this.isView };
        const res = await this.$api.post(
          `sign-pdf/envelopes/download/company-logo`,
          data
        );
        this.isLoading = false;
        if (res.status === 200) {
          //set company logo
          var companyLogo = res.data.result;

          if (companyLogo) {
            this.companyLogo =
              'data:' + companyLogo.mimeType + ';base64,' + companyLogo.file;
          }
          this.isError = false;
        }
      } catch (error) {
        this.companyLogo = '';
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    async changeCurrentDocument(document) {
      this.activeDocument = document;
      this.file = document.convertedFile;
      this.currentDocument = document.id;
      this.page = 1;

      const pdfDocument = await this.loadPdfDocument();
      this.signedPdf = await this.generatePdfSignedPlacements(
        pdfDocument.pages,
        pdfDocument.dateFont,
        pdfDocument.pdfDoc,
        this.activeDocument.template.id,
        1
      );
    },

    async getDocuments(token) {
      try {
        this.$api.setSxEnvironment(this.environment);
        const data = { Token: token };
        const response = await this.$api.post(
          `sign-pdf/envelopes/get-documents`,
          data
        );
        const downloadDocumentsResponse = await this.$api.post(
          `sign-pdf/envelopes/download-file`,
          data
        );
        this.originalDocumentsList = downloadDocumentsResponse.data;

        if (response.status === 200) {
          this.documentList = [];
          for (var d of response.data) {
            if (d.order != 0) this.documentList[d.order - 1] = d;
            else this.documentList.push(d);
          }

          if (this.documentList.includes(undefined))
            this.documentList = response.data;

          for (let i = 0; i < this.documentList.length; i++) {
            this.documentList[
              i
            ].convertedFile = this.originalDocumentsList.find(
              (f) => f.documentId === this.documentList[i].id
            ).fileContent.fileContents;
          }
          this.currentDocument = this.documentList[0].id;
          this.transactionId = this.documentList[0].transactionId;
          this.activeDocument = this.documentList[0];
          this.fileName = this.documentList[0].originalName;
          this.file = this.documentList[0].convertedFile;
          const pdfDocument = await this.loadPdfDocument();
          await this.getSignedPlacements(token);
          this.signedPdf = await this.generatePdfSignedPlacements(
            pdfDocument.pages,
            pdfDocument.dateFont,
            pdfDocument.pdfDoc,
            this.activeDocument.template.id,
            1
          );
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;
        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.isError = true;
        this.message = errorMessage;
      }
    },

    async getSignedPlacements(token) {
      try {
        const data = { Token: token };
        const response = await this.$api.post(
          `sign-pdf/envelopes/get-signed-placements`,
          data
        );
        if (response.status === 200) {
          this.signedPlacements = response.data;
        }
      } catch (error) {
        this.file = '';
        this.isLoading = false;
        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }
        this.isError = true;
        this.message = errorMessage;
      }
    },

    async generatePdfSignedPlacements(
      pages,
      dateFont,
      pdfDoc,
      templateId = null,
      isSignedPlaces = 0
    ) {
      const { width, height } = pages[0].getSize();
      for (let p of this.signedPlacements) {
        if (templateId && p.templateId === templateId) {
          const placementFont = await this.getFont(p.fontId, pdfDoc);
          var page;
          if (p.isLastPage && p.isLastPage == true) {
            page = pages[this.pagesCount - 1];
          } else {
            page = pages[p.page - 1];
          }
          if (p.valBlob && p.valBlob !== null && p.valBlob !== '') {
            const pngBytes = await (
              await fetch(`data:image/png;base64,${p.valBlob}`).then((res) =>
                res.blob()
              )
            ).arrayBuffer();
            const pngImage = await pdfDoc.embedPng(pngBytes);
            const pngDims = pngImage.scale(p.fontSize / pngImage.height);
            const timeZoneAbbr = new Intl.DateTimeFormat([], { timeZoneName: 'short' })
                .formatToParts(new Date())
                .find(part => part.type === 'timeZoneName')
                .value;
            if(p.elementTypeId === 5){
              
              const inititals = this.getInitials(p.signedByName);
              const signedBy = `${inititals}, ${p.createdAt}`;

              page.drawText(signedBy, {
              x: p.xPosition * width - 3.6,
              y: height - p.yPosition * height - p.fontSize / 1.286 + 26,
              size: 5,
              font: dateFont,
            });
            }else{
              
              const signedBy = `Signed By: ${p.signedByName ? p.signedByName : ''}, on: ${p.createdAt} ${timeZoneAbbr}`
              page.drawText(signedBy, {
              x: p.xPosition * width - 3.6,
              y: height - p.yPosition * height - p.fontSize / 1.286 + 26,
              size: 5,
              font: dateFont,
            });
            }
            page.drawLine({
              start: { 
                x: p.xPosition * width - 3,
                y: height -
                p.yPosition * height -
                p.fontSize / 1.286 +
                25 },

              end: { 
                x: p.xPosition * width - 3,
                y: height - p.yPosition * height - p.fontSize + 4 },
              thickness: 0.4,
              color: rgb(0, 0, 0),
              opacity: 1,
            })
            page.drawImage(pngImage, {
              x: p.xPosition * width,
              y: height - (p.elementTypeId === 5 ? -2 : 4) - p.yPosition * height - p.fontSize / 1.286,
              width: pngDims.width,
              height: pngDims.height,
            });
            if(p.elementTypeId === 5){
              page.drawText(`${p.valUuid}...`, {
              x: p.xPosition * width - 4,
              y: height - p.yPosition * height - p.fontSize / 1.286 - 5,
              size: 5,
              font: dateFont,
            });
            }
            else
            {
              page.drawText(`Digital Signature: ${p.valUuid}...`, {
              x: p.xPosition * width - 4,
              y: height - p.yPosition * height - p.fontSize / 1.286 - 7,
              size: 5,
              font: dateFont,
            });
            }
            
          } else if (p.valText && p.valText !== null) {
            page.drawText(p.valText, {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          } else if (p.valDate && p.valDate !== null) {
            page.drawText(dayjs(p.valDate).format('YYYY MMM DD'), {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          } else if (p.valDecimal && p.valDecimal !== null) {
            page.drawText('$' + p.valDecimal, {
              x: p.xPosition * width,
              y: height - p.yPosition * height - p.fontSize / 2,
              size: p.fontSize / 2,
              font: placementFont,
            });
          }
        }
      }
      if (isSignedPlaces === 1) return await pdfDoc.save();
    },

    async getDocumentData(token) {
      try {
        this.$api.setSxEnvironment(this.environment);

        const data = { Token: token, IsView: this.isView };
        const res = await this.$api.post(
          `sign-pdf/envelopes/document-data`,
          data
        );
        this.isLoading = false;
        if (res.status === 200) {
          this.documentName = res.data.transactionName;
          this.signeeName = res.data.signedByName;
          this.signedSignees = res.data.signedSignees;
          this.signedDate = res.data.signedOnDate;
          this.fileName = res.data.transactionName;
          this.transactionStatusId = res.data.transactionStatusId
          this.signedByName = res.data.signedByName;
          this.moduleRecordId = res.data.moduleRecordId;
          this.isError = false;
        }
      } catch (error) {
        this.elements = [];
        this.isLoading = false;

        let errorMessage = error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          }
        }

        this.isError = true;
        this.message = errorMessage;
      }
    },
    getPdfData() {
      return this.file;
    },
    async handleDownload() {
      const zipName = this.documentName;
      var zip = new JSZip();
      const signedOnDate = moment(this.signedOnDate).format('YYYYMMDD');
      var blobPdf;
      Bus.$emit('loading');
      for (var document of this.originalDocumentsList) {
        const pdfDocument = await this.loadPdfDocument(
          document.fileContent.fileContents
        );
        const templateId = this.documentList.find(
          (d) => d.id === document.documentId
        ).template.id;
        const doc = this.documentList.find((d) => d.id === document.documentId);
        const sPdf = await this.generatePdfSignedPlacements(
          pdfDocument.pages,
          pdfDocument.dateFont,
          pdfDocument.pdfDoc,
          templateId,
          1
        );
        blobPdf = new Blob([sPdf], { type: 'application/pdf' });

        zip.file(`${doc.signedName}${doc.signedExtension}`, blobPdf, {
          binary: true,
        });
      }
      Bus.$emit('loading');
      if (this.originalDocumentsList.length === 1) {
        const doc = this.documentList.find(
          (d) => d.id === this.originalDocumentsList[0].documentId
        );
        if(this.documentName)
          saveAs(blobPdf, `${this.documentName}.${this.moduleRecordId ? `${this.moduleRecordId}.` : ''}SignedOn.${signedOnDate}.pdf`);
        else
          saveAs(blobPdf, `document.SignedOn.${signedOnDate}.pdf`);
      } else {
        zip.generateAsync({ type: 'blob' }).then(function (content) {
          saveAs(content, `${zipName}.SignedOn.${signedOnDate}.zip`);
        });
      }
    },

    getInitials(str) {
      if(!str) return '';
      const words = str.split(' ');
      let initials = words[0].charAt(0);
      if (words.length > 1) {
        initials += words[1].charAt(0);
      }
      return initials;
    },

   startTimer() {
      this.timer = 10; // Start the timer at 10 seconds
      this.timerInterval = setInterval(() => {
        this.timer--;

        if (this.timer === 0) {
          clearInterval(this.timerInterval); // Stop the timer when it reaches 0 seconds
          this.redirect()
        }
      }, 1000); // Update and display the time every 1000ms (1 second)
    },

    stopTimer()
    {
      clearInterval(this.timerInterval);
      this.snackbarTimer = false;
    },

    redirect()
    {
      let module = '';

      

      if(this.moduleId == this.moduleIdExpense)
      {
        module = 'expenses'
      }
      else if(this.moduleId == this.moduleIdTimesheet)
      {
        module = 'timeattendances'
      }
      else if(this.moduleId == this.moduleIdPO)
      {
        module = 'purchase_orders'
      }

      let serverPrefix = process.env.VUE_APP_SERVER_PREFIX;
      let serverAddress =  process.env.VUE_APP_SERVER_ADDRESS;

      window.location.replace(
        `${serverPrefix}${this.environment}.${serverAddress}/${module}`
      );
    },

    getModuleName()
    {
      let module = 'Sign Pdf';

      if(this.moduleId == this.moduleIdExpense)
      {
        module = 'Expenses'
      }
      else if(this.moduleId == this.moduleIdTimesheet)
      {
        module = 'Time Sheets'
      }
      else if(this.moduleId == this.moduleIdPO)
      {
        module = 'Purchase Orders'
      }
      return module;
    },
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
.placing {
  cursor: crosshair;
}

.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content-pdf-view {
  flex-grow: 1;
  overflow-x: auto;
  background-color: #eae8ea;
}
.next-tag {
  // background-color: #f0f0f0;
  overflow: hidden;
  position: fixed; /* Set the navbar to fixed position */
  top: 100px; /* Position the navbar at the top of the page */
  left: 12%;
  // width: 100vw; /* Full width */
  z-index: 100;
}
html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.action-bar {
  background-color: #f0f0f0 !important;
  max-height: 52px;
}
.signUpFooter {
  background-color: #ff9800;
  overflow: hidden;
  max-height: 50px;
}
</style>
